import { config } from '../constants/Constants';
export const endpoints = {

  ///---Login service--///

    auth : {
        login : config.url.API_URL + 'ValidateUserJSON',
        forgetPassword : config.url.API_URL + 'ForgetPasswordJSON'
    },

  ///---Home service--///

    home : {
        installPolygons : config.url.API_URL + 'GetInstallationPolygonsJSON',
        loginCity : config.url.API_URL + 'QueryLoginCityJSON',
    },
}